:host {

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: var(--primary-font);
    font-weight: var(--font-weight-bold);
    line-height: 1;
    font-size: 10px;
    padding: 3px 3px 1px;
    color: var(--color-white);
    text-transform: uppercase;
    background-color: var(--color-livique-cherryade);
    border-radius: 3px;

    @include breakpointMin("md") {
      font-size: 12px;
      padding: 5px 5px 3px;
    }

    &.size-lg {
      font-size: 14px;
      padding: 7px 7px 5px;

      @include breakpointMin("md") {
        font-size: 18px;
        padding: 10px 10px 8px;
      }
    }

    &.gray {
      background-color: var(--color-bleached-silk);
    }
  }
}